import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setCustomerDeliberately,
  removeCustomerDeliberately,
  setCustomerVehicleDeliberatelyType,
  setDeliberatelyFileContent,
  setStoreFileType,
} from '../../Actions/reducer'
import { IApplicationState } from 'Store/types'
import CaptureImage from 'Components/CaptureImage'
import {
  getUploadLink,
  getVisitDeliberatelyData,
  uploadDeliberateliesFiles,
} from 'Application/Visits/Actions/action'
import Const from 'Utils/Consts'
import { IAutoPartModel } from 'Application/Visits/Actions/model'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import { useNavigate, useParams } from 'react-router-dom'
import Icon from 'Components/Icon'
import { useSettings } from 'Contexts/SettingsContext'
import { format } from 'react-string-format'
import PodSpaceImage from 'Components/Image/PodSpaceImage'

const ImageItem = (props: {
  name: string
  title: string
  isRequird: boolean
  isPodSpace: boolean
  data: IAutoPartModel | undefined
  onCapture: (image: string, fileType: string) => void
  onRemove: () => void
}) => {
  const [t] = useTranslation()
  const { settings } = useSettings()
  const imageMaxSize = settings?.REACT_APP_IMAGE_MAX_SIZE ?? Const.env.REACT_APP_IMAGE_MAX_SIZE

  const { customerDeliberately } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const [lastFileType, setLastFileType] = useState<'CAMERA' | 'FILE' | undefined>(undefined)
  const [imageMaxSizeError, setImageMaxSizeError] = useState<boolean>(false)
  const dispatch = useDispatch()

  const handleSelect = () => {
    const fileInput = document.getElementById(`fileInput_${props.name}`)
    fileInput?.click()
  }

  const handleFileChange = (e: any) => {
    const file = e.target.files[0]
    if (file) {
      if (Number(file.size / 1024) <= imageMaxSize) {
        setImageMaxSizeError(false)
        const reader = new FileReader()
        reader.onloadend = () => {
          const base64String = reader.result as string
          props.onCapture(base64String, file.type)
          setLastFileType('FILE')
        }
        reader.readAsDataURL(file)
      } else setImageMaxSizeError(true)
    }
  }

  return (
    <div
      className={`px-6 pb-6${customerDeliberately.loading && props.data?.status == 0 ? ' loading' : ''}`}
    >
      <div className="text-sm mb-2">تصویر {t(props.title)} را ثبت کنید.</div>
      <PodSpaceImage
        isPodSpace={props.isPodSpace}
        className="bg-gray-300 rounded-xl h-[342px] w-full flex items-end p-4 bg-cover bg-no-repeat bg-center"
        hashFile={props.data?.hashFile}
        fileId={props.data?.fileId}
        fileContent={props.data?.image}
        onLoad={(image: string) =>
          dispatch(setDeliberatelyFileContent({ id: props.data?.id, image }))
        }
        styles={
          props.data
            ? {
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                border: '2px solid #00647F',
                borderRadius: '10px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                width: '100%',
                height: '342px',
              }
            : {
                width: '100%',
                height: '342px',
                backgroundColor: '#f0f0f0',
                border: '2px solid #00647F',
                borderRadius: '10px',
              }
        }
      >
        <div style={{ position: 'relative', height: '100%' }}>
          <span style={{ position: 'absolute', top: 0, right: 0 }}>
            {t(props.isRequird ? 'REQUIRD' : 'UN_REQUIRD')}
          </span>

          {Number(props.data?.status) == 1 ? (
            <span style={{ position: 'absolute', top: 30 }}>{t('UPLOADED')}</span>
          ) : (
            ''
          )}

          {customerDeliberately.loading &&
            Number(props.data?.status) != 1 &&
            Number(props.data?.uploadProgress) > 0 &&
            Number(props.data?.uploadProgress) < 100 && (
              <span
                style={{ position: 'absolute', top: 30 }}
              >{`%${Math.round(Number(props.data?.uploadProgress))}`}</span>
            )}

          {/* <svg viewBox="0 0 250 250" className="circular-progress circular-progress-success w-11 h-11" style={{ '--progress': 80 }}>
            <circle className="bg"></circle>
            <circle className="fg"></circle>
          </svg> */}
        </div>

        <div className="flex justify-between items-center gap-2 w-full">
          {props.data && lastFileType == 'FILE' && (
            <button
              className="btn btn-inherit btn-lg flex gap-2 items-center justify-center w-full"
              onClick={() => handleSelect()}
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <Icon name="document-download" className="w-6 h-6" />
              <input
                id={`fileInput_${props.name}`}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              {t('AGAIN')}
            </button>
          )}
          {!customerDeliberately.loading && lastFileType != 'FILE' ? (
            <CaptureImage
              title={props.title}
              onCapture={(image: string) => {
                setLastFileType('CAMERA')
                setImageMaxSizeError(false)
                props.onCapture(image, 'image/png')
              }}
            >
              {props.data ? (
                <button
                  className="btn btn-inherit btn-lg flex gap-2 items-center justify-center w-full"
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                  <Icon name="camera" className="w-6 h-6" />
                  {t('AGAIN')}
                </button>
              ) : (
                <button className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full">
                  <Icon name="camera" className="w-6 h-6" />
                  {t('FROM_CAMERA')}
                </button>
              )}
            </CaptureImage>
          ) : (
            ''
          )}
          {props.data ? (
            <button
              className="btn btn-error btn-lg flex gap-2 items-center justify-center w-full "
              onClick={() => {
                props.onRemove()
                setLastFileType(undefined)
              }}
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <Icon name="#close-square" className="w-6 h-6" />
              {t('REMOVE')}
            </button>
          ) : (
            <button
              className="btn btn-inherit btn-lg flex gap-2 items-center justify-center w-full"
              onClick={() => handleSelect()}
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <Icon name="document-download" className="w-6 h-6" />
              <input
                id={`fileInput_${props.name}`}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              {t('FROM_FILE')}
            </button>
          )}
        </div>
      </PodSpaceImage>

      {imageMaxSizeError && (
        <div
          id="alert-error"
          className="flex items-center p-3 text-white rounded-xl bg-gray-800 dark:bg-gray-800 mt-1"
          role="alert"
        >
          <div className="bg-error/[.16] text-error p-2 rounded-lg flex justify-center items-center">
            <Icon name="ic_error" className="w-6 h-6" />
          </div>
          <span className="sr-only">error</span>
          <div className="ms-3 text-sm font-semibold grow">
            {format(t('IMAGE_MAX_SIZE_LIMIT_MESSAGE'), imageMaxSize)}
          </div>
        </div>
      )}
    </div>
  )
}

const IncompleteDocumentationPage = (props: { handleNext: () => void }) => {
  const [t] = useTranslation()
  let { visitId } = useParams()
  const { settings } = useSettings()
  const { loading, data } = useSelector((store: IApplicationState) => store.visits.deliberatelyData)
  const { customerDeliberately } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const completePendingVisitLoading = useSelector(
    (store: IApplicationState) => store.visits.completePendingVisit.loading,
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const uploadLinkSize =
    (settings?.REACT_APP_UPLOAD_LINK_SIZE ?? Const.env.REACT_APP_UPLOAD_LINK_SIZE) || 10200

  useEffect(() => {
    dispatch(getVisitDeliberatelyData(visitId))
  }, [])

  useEffect(() => {
    if (data?.nationalCardId)
      dispatch(
        setCustomerDeliberately({
          id: 1,
          image: '',
          fileType: 'Image/png',
          status: 1,
          uploadProgress: 100,
          fileId: data?.nationalCardId,
        }),
      )
    if (data?.nationalCardBackId)
      dispatch(
        setCustomerDeliberately({
          id: 2,
          image: '',
          fileType: 'Image/png',
          status: 1,
          uploadProgress: 100,
          fileId: data?.nationalCardBackId,
        }),
      )

    if (data?.vehicleDeliberatelyType == 1) {
      dispatch(setCustomerVehicleDeliberatelyType('CARD'))
      if (data?.vehicleCardId)
        dispatch(
          setCustomerDeliberately({
            id: 3,
            image: '',
            fileType: 'Image/png',
            status: 1,
            uploadProgress: 100,
            fileId: data?.vehicleCardId,
          }),
        )
      if (data?.vehicleCardBackId)
        dispatch(
          setCustomerDeliberately({
            id: 4,
            image: '',
            fileType: 'Image/png',
            status: 1,
            uploadProgress: 100,
            fileId: data?.vehicleCardBackId,
          }),
        )
    } else if (data?.vehicleDeliberatelyType == 2) {
      dispatch(setCustomerVehicleDeliberatelyType('DOC'))
      if (data?.vehicleDocId)
        dispatch(
          setCustomerDeliberately({
            id: 5,
            image: '',
            fileType: 'Image/png',
            status: 1,
            uploadProgress: 100,
            fileId: data?.vehicleDocId,
          }),
        )
    } else {
      dispatch(setCustomerVehicleDeliberatelyType('COMPANY_DOC'))
      if (data?.vehicleCompanyDocId)
        dispatch(
          setCustomerDeliberately({
            id: 6,
            image: '',
            fileType: 'Image/png',
            status: 1,
            uploadProgress: 100,
            fileId: data?.vehicleCompanyDocId,
          }),
        )
    }
  }, [data])

  const onSaveButtonClickHandle = () => {
    if (
      (customerDeliberately.vehicleDeliberatelyType === 'CARD' &&
        customerDeliberately.vehicleCard &&
        customerDeliberately.vehicleCardBack) ||
      (customerDeliberately.vehicleDeliberatelyType === 'DOC' && customerDeliberately.vehicleDoc) ||
      (customerDeliberately.vehicleDeliberatelyType === 'COMPANY_DOC' &&
        customerDeliberately.vehicleCompanyDoc)
    ) {
      dispatch(setStoreFileType(data.isPodSpaceEnable ? 'POD_SPACE' : 'SERVER'))
      if (data.isPodSpaceEnable) {
        dispatch(
          getUploadLink({
            data: { sizeInKB: uploadLinkSize, visitId: 0, type: 1 },
            visitId,
            navigate,
          }),
        )
      } else {
        dispatch(uploadDeliberateliesFiles({ visitId, navigate }))
      }
    }
  }

  return (
    <React.Fragment>
      <div className={`flex justify-between items-center h-16 px-6 shrink-0`}>
        <div className="flex justify-between items-center gap-2">
          <div onClick={() => navigate(VisitsPaths.VisitsMain)}>
            <Icon name="arrow-right" className="w-6 h-6 text-gray-700" />
          </div>
          <div className="text-lg font-bold pl-2">{t('تکمیل مدارک')}</div>
        </div>
      </div>

      <div className="flex flex-col grow overflow-auto">
        <ImageItem
          name="nationalCard"
          title={t('NATIONAL_CARD_FRONT')}
          isRequird={false}
          isPodSpace={data?.isPodSpaceEnable}
          data={customerDeliberately.nationalCard}
          onCapture={(image: string, fileType: string) =>
            dispatch(
              setCustomerDeliberately({
                id: 1,
                image: image,
                fileType: fileType,
                status: 0,
                uploadProgress: 0,
              }),
            )
          }
          onRemove={() => dispatch(removeCustomerDeliberately(1))}
        />
        <ImageItem
          name="nationalCardBack"
          title={t('NATIONAL_CARD_BACK')}
          isRequird={false}
          isPodSpace={data?.isPodSpaceEnable}
          data={customerDeliberately.nationalCardBack}
          onCapture={(image: string, fileType: string) =>
            dispatch(
              setCustomerDeliberately({
                id: 2,
                image: image,
                fileType: fileType,
                status: 0,
                uploadProgress: 0,
              }),
            )
          }
          onRemove={() => dispatch(removeCustomerDeliberately(2))}
        />

        <div style={{ margin: '10px' }}>
          <h2>{t('VEHICLE_DELIBERATELY_TYPE')}</h2>
          <div className="" style={{ marginTop: '8px', marginBottom: '8px' }}>
            <div className="flex items-center me-4 mb-3">
              <input
                id="vehicleCardRadio"
                name="vehicleCardRadio"
                type="radio"
                value="CARD"
                checked={customerDeliberately.vehicleDeliberatelyType == 'CARD'}
                onChange={e => dispatch(setCustomerVehicleDeliberatelyType(e.currentTarget.value))}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="vehicleCardRadio"
                className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                style={{ marginRight: '8px' }}
              >
                {String(t('VEHICLE_CARD'))}
              </label>
            </div>
            <div className="flex items-center me-4 mb-3">
              <input
                id="vehicleDocRadio"
                name="vehicleDocRadio"
                type="radio"
                value="DOC"
                checked={customerDeliberately.vehicleDeliberatelyType == 'DOC'}
                onChange={e => dispatch(setCustomerVehicleDeliberatelyType(e.currentTarget.value))}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="vehicleDocRadio"
                className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                style={{ marginRight: '8px' }}
              >
                {String(t('VEHICLE_DOC'))}
              </label>
            </div>
            <div className="flex items-center me-4">
              <input
                id="vehicleCompanyRadio"
                name="vehicleCompanyRadio"
                type="radio"
                value="COMPANY_DOC"
                checked={customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'}
                onChange={e => dispatch(setCustomerVehicleDeliberatelyType(e.currentTarget.value))}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="vehicleCompanyRadio"
                className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                style={{ marginRight: '8px' }}
              >
                {String(t('VEHICLE_COMPANY_DOC'))}
              </label>
            </div>
          </div>
        </div>

        {customerDeliberately.vehicleDeliberatelyType == 'CARD' ? (
          <React.Fragment>
            <ImageItem
              name="vehicleCard"
              title={t('VEHICLE_CARD_FRONT')}
              isRequird={true}
              isPodSpace={data?.isPodSpaceEnable}
              data={customerDeliberately.vehicleCard}
              onCapture={(image: string, fileType: string) =>
                dispatch(
                  setCustomerDeliberately({
                    id: 3,
                    image: image,
                    fileType: fileType,
                    status: 0,
                    uploadProgress: 0,
                  }),
                )
              }
              onRemove={() => dispatch(removeCustomerDeliberately(3))}
            />
            <ImageItem
              name="vehicleCardBack"
              title={t('VEHICLE_CARD_BACK')}
              isRequird={true}
              isPodSpace={data?.isPodSpaceEnable}
              data={customerDeliberately.vehicleCardBack}
              onCapture={(image: string, fileType: string) =>
                dispatch(
                  setCustomerDeliberately({
                    id: 4,
                    image: image,
                    fileType: fileType,
                    status: 0,
                    uploadProgress: 0,
                  }),
                )
              }
              onRemove={() => dispatch(removeCustomerDeliberately(4))}
            />
          </React.Fragment>
        ) : customerDeliberately.vehicleDeliberatelyType == 'DOC' ? (
          <ImageItem
            name="vehicleDoc"
            title={t('VEHICLE_DOC')}
            isRequird={true}
            isPodSpace={data?.isPodSpaceEnable}
            data={customerDeliberately.vehicleDoc}
            onCapture={(image: string, fileType: string) =>
              dispatch(
                setCustomerDeliberately({
                  id: 5,
                  image: image,
                  fileType: fileType,
                  status: 0,
                  uploadProgress: 0,
                }),
              )
            }
            onRemove={() => dispatch(removeCustomerDeliberately(5))}
          />
        ) : (
          <ImageItem
            name="vehicleCompanyDoc"
            title={t('VEHICLE_COMPANY_DOC')}
            isRequird={true}
            isPodSpace={data?.isPodSpaceEnable}
            data={customerDeliberately.vehicleCompanyDoc}
            onCapture={(image: string, fileType: string) =>
              dispatch(
                setCustomerDeliberately({
                  id: 6,
                  image: image,
                  fileType: fileType,
                  status: 0,
                  uploadProgress: 0,
                }),
              )
            }
            onRemove={() => dispatch(removeCustomerDeliberately(6))}
          />
        )}
      </div>

      <div className="cta">
        <button
          className="btn btn-primary btn-lg flex items-center justify-center gap-2"
          disabled={
            loading ||
            customerDeliberately.loading ||
            completePendingVisitLoading ||
            Boolean(
              !(
                (customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
                  customerDeliberately.vehicleCard &&
                  customerDeliberately.vehicleCardBack) ||
                (customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
                  customerDeliberately.vehicleDoc) ||
                (customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
                  customerDeliberately.vehicleCompanyDoc)
              ),
            )
          }
          onClick={onSaveButtonClickHandle}
        >
          {t('SAVE')}
          <Icon name="arrow-left" className="w-6 h-6" />
        </button>
      </div>
    </React.Fragment>
  )
}

export default IncompleteDocumentationPage
